import { ChangeDetectionStrategy, Component, HostListener } from "@angular/core";
import { AppRoutes, Miliseconds, MIN_DESKTOP_VIEW, NEWS_PER_PAGE } from "src/app/constants";
import { Observable } from "rxjs";
import * as NewsActions from "src/app/store/news/actions";
import * as UserActions from "src/app/store/user/actions";
import * as ReportActions from "src/app/store/report/actions";
import * as FromUser from "src/app/store/user/selectors";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { ActionButtonDto, UserDto } from "@api";
import { IonRouterOutlet } from "@ionic/angular";
import { NavigationService } from "src/app/services/navigation/navigation.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePage {
  public routes: typeof AppRoutes = AppRoutes;
  public breadcrumbs = [{ name: "Dashboard", link: `/${this.routes.home}` }];
  public user$: Observable<UserDto> = this.store.select(FromUser.selectUser);
  public actionButton$: Observable<ActionButtonDto> = this.store.select(FromUser.selectActionButton);
  public showResults: false;
  public isMobileLikeView: boolean;

  private interval: any;

  constructor(private store: Store<RootState>, private navigationService: NavigationService, private routerOutlet: IonRouterOutlet) {
    this.isMobileLikeView = window.innerWidth <= MIN_DESKTOP_VIEW;
  }

  @HostListener("window:resize", ["$event"])
  protected onResize(event: any): void {
    this.isMobileLikeView = event.target.innerWidth <= MIN_DESKTOP_VIEW;
  }

  public handleActionButtonClick(actionButton: ActionButtonDto): void {
    this.navigationService.handleNavigationTo(actionButton.actionLink, this.routerOutlet.nativeEl);
  }

  protected ionViewWillEnter(): void {
    this.interval = setInterval(() => this.refresh(), Miliseconds.OneMinute);
  }

  protected ionViewDidEnter(): void {
    this.store.dispatch(ReportActions.getReportResponses({ slug: AppRoutes.successReport }));
    this.refresh();
  }

  protected ionViewWillLeave(): void {
    clearInterval(this.interval);
  }

  private refresh(): void {
    this.store.dispatch(NewsActions.getNews({ limit: NEWS_PER_PAGE, page: 1 }));
    this.store.dispatch(UserActions.getActionButton());
  }
}
